import http from '@/requests/http'

class Queue {
  static all (params) {
    return http.post('queues', params)
  }
  static history (params) {
    return http.post('queues/history', params)
  }
  static status (params) {
    return http.post('queues/status', params)
  }
  static view (params) {
    return http.post('queues/view', params)
  }
  static updateLabel (params) {
    return http.post('queues/label/update', params)
  }
  static queuesOptions (params) {
    return http.post('queues/options', params)
  }
  static queueExtension (params) {
    return http.post('queues/extensions', params)
  }
  static storeQueueExtension (params) {
    return http.post('queues/store-extensions', params)
  }
  static cdrStatusReport (params) {
    return http.post('queues/cdr-status-report', params)
  }
  static cdrHistory (params) {
    return http.post('queues/cdr-history', params)
  }
}

export default Queue
